import { Injectable } from "@angular/core";
import { ConfigService } from "./config.service";


@Injectable()
export class EnvironmentService {
    constructor(private configService: ConfigService) {}

    public get envName() {
        return this.configService.get("envName");
    }

    public get isProdIn(): boolean {
        return this.envName.toLowerCase() === "prodin";
    }

    public get isQA(): boolean {
        return this.envName.toLowerCase() === "test" ||  this.envName.toLowerCase() === 'qa-02';
    }

    public get isPreview(): boolean {
        return this.envName.toLowerCase() === "preview";
    }
    public get isProd(): boolean {
        return this.envName.toLowerCase() === "prod" || this.envName.toLowerCase() === "prod-euwest1";
    }
    public get s3ImageUrl():string {
        return this.configService.get('aws').downloadUrl + '/' + this.configService.get('aws').cdnBucket;
    }
    public get isFSPEnv():boolean {
        return (this.envName.toLowerCase() === 'qa-02' ||
        this.envName.toLowerCase() === "preview" || this.envName.toLowerCase() === "prodin");
    }
    public get isEtisalat(): boolean {
        return this.envName.toLowerCase() === "qa" || this.envName.toLowerCase() === "preview-etisalat" || this.envName.toLowerCase() === "prod-uswest2";
    }
    public get isEtisalatQA(): boolean {
        return this.envName.toLowerCase() === "qa";
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/environment.service.ts